export function getTextInputValue(text, event) {
  if (
    event
    && event.type === 'paste'
    && event.clipboardData
    && event.clipboardData.getData
    && (
      !text
      || !text.length
      || text !== event.clipboardData.getData('Text')
    )
  ) {
    return event.clipboardData.getData('Text');
  } else if (
    event
    && event.target
    && event.target.innerText === 'clear'
  ) {
    return '';
  }
  return text;
}  